import machine_app_implementation_loader from "./models/machine_app_implementation_loader";
import machine_app_state from "./models/machine_app_state";

export const prerequisiteValidator = (pType) => {
  const machineAppInterface = machine_app_state.getInterface();
  const prerequisites = machine_app_implementation_loader.instance.getPrerequisites(pType);
  if(!prerequisites){
    return {
      success: true,
      configSummary: {}
    };
  }

  const configData = {
    robot: {
      isRequired:    !!prerequisites.robot,
      isConfigured:  !!prerequisites.robot && machineAppInterface.listRobots().length >= prerequisites.robot,
      qtyRequired:   prerequisites.robot || 0,
      qtyConfigured: machineAppInterface.listRobots().length
    },
    actuator: {
      isRequired:    !!prerequisites.actuator,
      isConfigured:  !!prerequisites.actuator && machineAppInterface.listAxes().length >= prerequisites.actuator,
      qtyRequired:   prerequisites.actuator || 0,
      qtyConfigured: machineAppInterface.listAxes().length
    },
    input: {
      isRequired:    !!prerequisites.input,
      isConfigured:  !!prerequisites.input && machineAppInterface.listInputs().length >= prerequisites.input,
      qtyRequired:   prerequisites.input || 0,
      qtyConfigured: machineAppInterface.listInputs().length
    },
    output: {
      isRequired:    !!prerequisites.output,
      isConfigured:  !!prerequisites.output && machineAppInterface.listOutputs().length >= prerequisites.output,
      qtyRequired:   prerequisites.output || 0,
      qtyConfigured: machineAppInterface.listOutputs().length
    }
  };

  const success = Object.keys(configData).every(item => configData[item].isRequired ? configData[item].isConfigured : true);

  return {
    success: success,
    configSummary: configData
  };
};


